import { lazy } from 'react'

const ResearcherPage = lazy(() => import('./ResearcherWorkspace'))

export { ResearcherPage }
